import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { RouteEffects } from "@/components/site/RouteEffects";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { LegalDialog } from "@/components/site/Legal";
import { MobileCta } from "@/components/site/MobileCta";
import Home from "@/pages/Home";
import PriceList from "@/pages/PriceList";
import LegalPage from "@/pages/LegalPage";

const TOAST = { style: { background: "#FFFDF9", border: "1px solid rgba(197,155,39,0.35)", color: "#2D241E" } };

const Site = () => {
  const [treatment, setTreatment] = useState("");
  const [legal, setLegal] = useState(null);
  const openPrivacy = () => setLegal("datenschutz");

  return (
    <div className="grain min-h-screen bg-cream font-sans text-ink">
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Home treatment={treatment} onSelect={setTreatment} onOpenPrivacy={openPrivacy} />} />
          <Route path="/preisliste" element={<PriceList onSelect={setTreatment} />} />
          <Route path="/impressum" element={<LegalPage kind="impressum" />} />
          <Route path="/datenschutz" element={<LegalPage kind="datenschutz" />} />
          <Route path="/agb" element={<LegalPage kind="agb" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <LegalDialog open={legal} onClose={() => setLegal(null)} />
      <MobileCta />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <RouteEffects />
      <Routes>
        <Route path="*" element={<Site />} />
      </Routes>
      <Toaster position="top-center" toastOptions={TOAST} />
    </BrowserRouter>
  );
}

export default App;
